// extracted by mini-css-extract-plugin
export default {"downloadFile":"download-statement-modal_downloadFile__XpdDd"};